import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import { Buttton, Header, Inputs, Modaal, Sides } from "../../../components";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { t } from "i18next";

const GenerateInvoice = ({ loginData }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appointment = location.state?.appointment;
    const [showModal1, setShowModal1] = useState(false);
    const [credentials, setCredentials] = useState({
        bookingId: "",
        patientFirstName: "",
        patientLastName: "",
        patientSocialInsuranceNumber: "",
        patientPhoneNumber: "",
        patientPostCode: "",
        patientCity: "",
        patientCountry: "",
        senderFirstName: "",
        senderLastName: "",
        senderSpecialistName: "",
        senderClinicsName: "",
        senderDoctorRegistrationNumber: "",
        senderEmail: "",
        senderAddress: "",
        senderPostCode: "",
        senderCity: "",
        senderCountry: "",
        senderSocialInsuranceNumber: "",
        senderPhoneNumber: "",
        invoiceNumber: "",
        invoiceDate: "",
        currency: "",
        TotalAmount: "",
        diagnosticConclusion: "",
    });
    const [credentials1, setCredentials1] = useState({
        discount: "",
    });
    const [errors, setErrors] = useState({});
    const [errors1, setErrors1] = useState({});
    useEffect(() => {
        if (appointment?.appointmentGuid) {
            setCredentials((prev) => ({
                ...prev,
                bookingId: appointment?.bookingId,
                senderFirstName: appointment?.doctorFirstName,
                senderLastName: appointment?.doctorLastName,
                senderSpecialistName:
                    appointment?.doctorFirstName + " " + appointment?.doctorLastName,
            }));

            dispatch(
                actionDoctor.getInvoice(
                    appointment.appointmentGuid,
                    false,
                    loginData?.currencyCode
                )
            );
        }
    }, [appointment.appointmentGuid, appointment?.bookingId, appointment?.doctorFirstName, appointment?.doctorLastName, dispatch, loginData?.currencyCode]);
    useEffect(() => {
        if (loginData?.userGuid && loginData?.clinicGuid) {
            dispatch(
                actionDoctor.getInvoiceSettingByGuid(
                    loginData.userGuid,
                    loginData.clinicGuid
                )
            );
        }
    }, [loginData?.userGuid, loginData?.clinicGuid, dispatch]);
    const getInvoiceData = useSelector(
        (state) => state.doctor.getInvoiceData?.data
    );

    const getInvoiceSettingByGuidData = useSelector(
        (state) => state.doctor.getInvoiceSettingByGuidData?.data
    );
    useEffect(() => {
        if (getInvoiceData) {
            setCredentials((prev) => ({
                ...prev,
                patientFirstName: getInvoiceData?.result?.patientFirstName || "",
                patientLastName: getInvoiceData?.result?.patientLastName || "",
                socialSecurityNumber:
                    getInvoiceData?.result?.socialSecurityNumber || "",
                patientPhoneNumber: getInvoiceData?.result?.patientPhoneNumber || "",
                patientAddress: getInvoiceData?.result?.patientAddress || "",
                currency: getInvoiceData?.result?.currency || "",
                TotalAmount: getInvoiceData?.result?.diagnosticReport?.appDetail?.consultFees || "",
                diagnosticConclusion:
                    getInvoiceData.result.diagnosticReport.diagnosticConclusion,
                additionalService: getInvoiceData.result.additionalService,
            }));
        }
    }, [getInvoiceData]);
    useEffect(() => {
        if (getInvoiceSettingByGuidData) {
            setCredentials((prev) => ({
                ...prev,
                senderClinicsName:
                    getInvoiceSettingByGuidData?.result[0]?.clinicName || "",
                senderDoctorRegistrationNumber:
                    getInvoiceSettingByGuidData?.result[0]?.doctorRegistrationNumber ||
                    "",
                senderAddress:
                    getInvoiceSettingByGuidData?.result[0]?.clinicAddress || "",
                senderPhoneNumber:
                    getInvoiceSettingByGuidData?.result[0]?.phoneNumber || "",
                senderEmail: getInvoiceSettingByGuidData?.result[0]?.emailAddress || "",
            }));
        }
    }, [getInvoiceSettingByGuidData]);
    useEffect(() => {
        if (
            getInvoiceSettingByGuidData?.result?.length > 0 &&
            getInvoiceData?.result
        ) {
            const payload = {
                InvoiceSettingGuid:
                    getInvoiceSettingByGuidData.result[0].invoiceSettingGuid,
                AppointmentGuid: appointment?.appointmentGuid,
                DoctorGuid: loginData?.userGuid,
                TotalAmount: getInvoiceData.result.consultingFees || 0,
            };

            if (
                payload.InvoiceSettingGuid &&
                payload.AppointmentGuid &&
                payload.DoctorGuid
            ) {
                dispatch(actionDoctor.postSaveInvoiceList(payload));
            }
        }
    }, [
        getInvoiceSettingByGuidData,
        getInvoiceData,
        appointment,
        loginData,
        dispatch,
    ]);
    const postSaveInvoiceListData = useSelector(
        (state) => state.doctor.postSaveInvoiceListData?.data
    );
    useEffect(() => {
        if (postSaveInvoiceListData) {
            setCredentials((prev) => ({
                ...prev,
                invoiceNumber: postSaveInvoiceListData?.result.invoiceNumber,
                invoiceDate: postSaveInvoiceListData?.result.createdAt,
            }));
        }
    }, [postSaveInvoiceListData]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setCredentials1((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
        setErrors1((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        navigate("/doctor/pdf-preview", {
            state: {
                invoiceDetails: credentials,
                invoiceDetails1: credentials1,
                appointment: appointment,
            },
        });
    };

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage pageHeading={t("generate_invoice")} />
                </Col>
            </Row>
            <Row className="exado-row1 ">
                <Col>
                    <section className="generate-invoice-section">
                        <Form onSubmit={handleSubmit} className="generate-invoice-form">
                            <Row className="exado-row1 generate-invoice-ul">
                                <Col>
                                    <ul className="generate-invoice-ul">
                                        <li className="generate-invoice-li exado-title-seven">
                                            {t("invoice_number")} : {credentials?.invoiceNumber}
                                        </li>
                                        <li className="generate-invoice-li exado-title-seven">
                                            {t("Patient.patients")} {t("booking_id")} :{" "}
                                            {credentials?.bookingId}
                                        </li>
                                        <li className="generate-invoice-li exado-title-seven">
                                            {t("invoice_date")} :{" "}
                                            {new Date(credentials?.invoiceDate)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, ".")}
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                            <Row className="exado-row1 ">
                                <Form.Label className="exado-title-seven">
                                    {t("patient_information")} ( {t("invoice_receiver")} )
                                </Form.Label>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientFirstName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientFirstName}
                                                </span>
                                            ) : (
                                                t("first_name")
                                            )
                                        }
                                        value={credentials.patientFirstName}
                                        name="patientFirstName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientFirstName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientLastName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientLastName}
                                                </span>
                                            ) : (
                                                t("last_name")
                                            )
                                        }
                                        value={credentials.patientLastName}
                                        name="patientLastName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientLastName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientSocialInsuranceNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientSocialInsuranceNumber}
                                                </span>
                                            ) : (
                                                t("social_insurance_number")
                                            )
                                        }
                                        value={credentials.patientSocialInsuranceNumber}
                                        name="patientSocialInsuranceNumber"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientSocialInsuranceNumber
                                            ? "form-group-error"
                                            : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientPhoneNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientPhoneNumber}
                                                </span>
                                            ) : (
                                                `${t("phone_number")} ( ${t("Optional")}  )`
                                            )
                                        }
                                        value={credentials.patientPhoneNumber}
                                        name="patientPhoneNumber"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientPhoneNumber ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={12} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientAddress ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientAddress}
                                                </span>
                                            ) : (
                                                t("generate_invoices.address")
                                            )
                                        }
                                        value={credentials.patientAddress}
                                        name="patientAddress"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientAddress ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientPostCode ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientPostCode}
                                                </span>
                                            ) : (
                                                t("Post_Code")
                                            )
                                        }
                                        value={credentials.patientPostCode}
                                        name="patientPostCode"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientPostCode ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientCity ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientCity}
                                                </span>
                                            ) : (
                                                t("City")
                                            )
                                        }
                                        value={credentials.patientCity}
                                        name="patientCity"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientCity ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.patientCountry ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.patientCountry}
                                                </span>
                                            ) : (
                                                t("Country")
                                            )
                                        }
                                        value={credentials.patientCountry}
                                        name="patientCountry"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.patientCountry ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                            </Row>
                            <Row className="exado-row1 ">
                                <Form.Label className="exado-title-seven">
                                    {t("sender_information")}
                                </Form.Label>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderFirstName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderFirstName}
                                                </span>
                                            ) : (
                                                t("first_name")
                                            )
                                        }
                                        value={credentials.senderFirstName}
                                        name="senderFirstName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderFirstName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderLastName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderLastName}
                                                </span>
                                            ) : (
                                                t("last_name")
                                            )
                                        }
                                        value={credentials.senderLastName}
                                        name="senderLastName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderLastName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderSpecialistName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderSpecialistName}
                                                </span>
                                            ) : (
                                                t("specialist_name")
                                            )
                                        }
                                        value={credentials.senderSpecialistName}
                                        name="senderSpecialistName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderSpecialistName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderClinicsName ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderClinicsName}
                                                </span>
                                            ) : (
                                                t("clinics_name")
                                            )
                                        }
                                        value={credentials.senderClinicsName}
                                        name="senderClinicsName"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderClinicsName ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderDoctorRegistrationNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderDoctorRegistrationNumber}
                                                </span>
                                            ) : (
                                                t("doctors_registration_number")
                                            )
                                        }
                                        value={credentials.senderDoctorRegistrationNumber}
                                        name="senderDoctorRegistrationNumber"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderDoctorRegistrationNumber
                                            ? "form-group-error"
                                            : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderEmail ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderEmail}
                                                </span>
                                            ) : (
                                                `${t("email")} ${t("Address")}`
                                            )
                                        }
                                        value={credentials.senderEmail}
                                        name="senderEmail"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderEmail ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={12} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderAddress ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderAddress}
                                                </span>
                                            ) : (
                                                t("generate_invoices.address")
                                            )
                                        }
                                        value={credentials.senderAddress}
                                        name="senderAddress"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderAddress ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderPostCode ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderPostCode}
                                                </span>
                                            ) : (
                                                t("Post_Code")
                                            )
                                        }
                                        value={credentials.senderPostCode}
                                        name="senderPostCode"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderPostCode ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderCity ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderCity}
                                                </span>
                                            ) : (
                                                t("City")
                                            )
                                        }
                                        value={credentials.senderCity}
                                        name="senderCity"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderCity ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={4} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderCountry ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderCountry}
                                                </span>
                                            ) : (
                                                t("Country")
                                            )
                                        }
                                        value={credentials.senderCountry}
                                        name="senderCountry"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderCountry ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>

                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderSocialInsuranceNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderSocialInsuranceNumber}
                                                </span>
                                            ) : (
                                                t("social_insurance_number")
                                            )
                                        }
                                        value={credentials.senderSocialInsuranceNumber}
                                        name="senderSocialInsuranceNumber"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderSocialInsuranceNumber
                                            ? "form-group-error"
                                            : ""
                                            }`}
                                    />
                                </Col>
                                <Col md={6} className="gi-col">
                                    <Inputs.FormInputs
                                        label={
                                            errors.senderPhoneNumber ? (
                                                <span className="error-message">
                                                    {" "}
                                                    {errors.senderPhoneNumber}
                                                </span>
                                            ) : (
                                                t("phone_number")
                                            )
                                        }
                                        value={credentials.senderPhoneNumber}
                                        name="senderPhoneNumber"
                                        onChange={handleChange}
                                        grpClassname={`form-group ${errors.senderPhoneNumber ? "form-group-error" : ""
                                            }`}
                                    />
                                </Col>
                            </Row>
                            <Row className="exado-row1">
                                <Col className="gibtnrow">
                                    <Buttton.Buttton
                                        type="button"
                                        children={t("add_discount")}
                                        className="btn-border-Aqua_Teal"
                                        onClick={() => setShowModal1(true)}
                                    />
                                    <Buttton.Buttton
                                        children={t("view_invoice")}
                                        className="btn-border-Aqua_Teal"
                                        onClick={() =>
                                            navigate("/doctor/pdf-preview", {
                                                state: {
                                                    invoiceDetails: credentials,
                                                    invoiceDetails1: credentials1,
                                                    appointment: appointment,
                                                },
                                            })
                                        }
                                    />
                                    <Buttton.Buttton
                                        children={t("generate")}
                                        className="btn-solid-Aqua_Teal"
                                        onClick={() =>
                                            navigate("/doctor/pdf-preview", {
                                                state: {
                                                    invoiceDetails: credentials,
                                                    invoiceDetails1: credentials1,
                                                    appointment: appointment,
                                                    generate: true
                                                },
                                            })
                                        }
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </section>
                </Col>
            </Row>
        </Container>
    );

    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
            <Modaal.Modaal
                show={showModal1}
                onHide={() => {
                    setShowModal1(false);
                    setCredentials1({ discount: "" });
                }}
                centered="true"
                size="xl"
                title={<h2 className="exado-title-nine">{t("add_discount")}</h2>}
                bodyContent={
                    <Form className="my-fees-form">
                        <Form.Label className="exado-title-six add-lable ">
                            Enter discount %
                        </Form.Label>
                        <Row className="fees-row">
                            <Inputs.FormInputs
                                value={credentials1.discount}
                                name="discount"
                                onChange={handleChange1}
                                grpClassname={`form-group ${errors1.discount ? "form-group-error" : ""
                                    }`}
                            />
                        </Row>
                    </Form>
                }
                footer={
                    <Buttton.Buttton
                        children="SAVE"
                        className="btn-solid-Aqua_Teal"
                        onClick={() => setShowModal1(false)}
                    />
                }
                backdrop="static"
                className="input-modal add-discount-modal"
            />
        </>
    );
};

export default GenerateInvoice;
